import axios from "axios";
import store from '@/store'
import router from "@/router";
import {toast} from "../class/Notification";
import {findObjectIndex} from "../class/Converter";

const reshapeForm = (form) => {
    const formData = new FormData();
    formData.append('name', form.name);
    formData.append('value', (form.name === 'icon' || form.name === 'loadingIcon') ? form.icon : form.value);
    return formData
}

export default {
    namespaced: true,
    state: {
        siteInfos: [],
        attributes: [],
    },
    mutations: {
        setSiteInfos(state, siteInfos) {
            state.siteInfos = siteInfos
        },
        setAttributes(state, attributes) {
            state.attributes = attributes
        },
        deleteSiteInfo: (state, siteInfo) => {
            state.siteInfos.splice(findObjectIndex(state.siteInfos, siteInfo), 1)
        },
    },
    actions: {
        async getSiteInfos({commit}) {
            let res = await axios.get(`site-info`);

            res = res.data.data;
            commit('setSiteInfos', res.data)
            commit('setAttributes', res.attributes)

            return res
        },
        async getSiteInfo({commit}, form) {
            return await axios.get(`site-info/${form.id}`)
        },
        deleteSiteInfo({commit}, siteInfo) {
            axios.delete(`site-info/${siteInfo.id}`)
                .then(res => {
                    const siteInfo = res.data.data;

                    toast('تنظیمات با موفقیت حذف شد ', 'تنظیمات با موفقیت حذف شد ')
                    commit('deleteSiteInfo', siteInfo)
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                });
        },
        createSiteInfo({commit}, form) {
            const formData = reshapeForm(form);
            axios.post(`site-info`, formData)
                .then(res => {

                    toast('تنظیمات با موفقیت ثبت شد ', 'تنظیمات با موفقیت ثبت شد ')

                    router.push({name: "SiteInfo"})
                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                });

        },
        updateSiteInfo({commit}, form) {
            const formData = reshapeForm(form);
            formData.append('_method', 'PUT');

            axios.post(`/site-info/${form.id}`, formData)
                .then(res => {

                    toast('عملیات با موفقیت انجام شد', 'به روز رسانی تنظیمات با موفقیت انجام شد')

                })
                .catch(error => {
                    toast.error(error.response.data.message);
                    console.log(error)
                });


        },
    },
    getters: {
        getSiteInfos: state => state.siteInfos,
        getAttributes: state => state.attributes,
    }
}